/**
 * Pages that render without the site navigation and footer. Ad landing pages
 * carry their own header and must not offer a way out of the funnel.
 *
 * Matched with `includes`, so a prefix covers every locale and every param.
 */
export const CHROMELESS_PATHS = ['/lp/voucher-campaigns']

export const getIsChromelessPath = (pathname: string) =>
    CHROMELESS_PATHS.some((path) => pathname.includes(path))
